var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessfactors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.065 40.085l-.004-3.904C57.2 22.374 71.688 17.098 81.49 22.884c1.086.64 1.736.534 2.77-.06 11.185-6.445 24.817 1.178 25.43 14.052.296 6.222-2.114 11.373-5.753 16.067-6.05 7.804-13.516 14.288-20.35 21.362-.515.533-.898.608-1.447.03-7.364-7.732-15.694-14.57-21.84-23.43-2.263-3.26-3.864-6.808-4.232-10.82zm47.735-2.027c-.074-4.832-1.833-8.743-6.49-10.72-4.463-1.893-8.596-1.105-12.17 2.232-2.28 2.128-2.272 2.14-4.534.012-3.244-3.052-7.018-3.965-11.258-2.618-4.145 1.317-6.512 4.34-7.292 8.482-.893 4.74.808 8.895 3.504 12.7 4.735 6.682 10.936 12.008 16.606 17.825.444.455.772.568 1.278.04 5.933-6.192 12.6-11.73 17.35-18.985 1.778-2.712 3.08-5.62 3.01-8.97z",
    fill: "#f1b300",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfactors);
export default __webpack_public_path__ + "static/media/Successfactors.a05f82399da807b5b3bf4ef5f589053e.svg";
export { ForwardRef as ReactComponent };